const applyCubemapComponent = () => ({
  init() {
    this.el.addEventListener('model-loaded', () => {
      const mesh = this.el.getObject3D('mesh')
      if (!mesh) {
        console.warn('No mesh found on', this.el.id)
        return
      }

      // Use a dummy entity with resolved envMap applied
      const dummyMaterial = document.querySelector('#envProbe')?.getObject3D('mesh')?.material

      if (!dummyMaterial || !dummyMaterial.envMap) {
        console.warn('No envMap found from dummy probe (envProbe).')
        return
      }

      const envMap = dummyMaterial.envMap

      mesh.traverse((node) => {
        if (node.isMesh && node.material) {
          node.material.envMap = envMap
          node.material.metalness = node.material.metalness ?? 1.0
          node.material.roughness = node.material.roughness ?? 0.1
          node.material.needsUpdate = true
        }
      })

      console.log(`✅ Cubemap from #envProbe applied to: ${this.el.id}`)
    })
  }
})

export { applyCubemapComponent }